"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { catchError, exhaustMap, map, switchMap } from "rxjs/operators";

import { requestTypes } from "../_constants";
import { optimumFrictionConstants } from "../_constants/optimumFriction.constants";
import { getRequestHeader } from "../../_helpers/request.header";
import {
     ajaxError,
     optimumFrictionCommitTrainingImportComplete,
     optimumFrictionGetReportComplete,
     optimumFrictionGetReportExportComplete,
     optimumFrictionPreviewTrainingImportComplete,
     optimumFrictionGetTrainingImportsComplete,
} from "../_actions";

const post = (url, complete, operator) =>
     operator((incoming) =>
          ajax
               .post(
                    url,
                    incoming.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
               )
               .pipe(
                    map((ajaxResponse) => complete(ajaxResponse.response)),
                    catchError((error) => of(ajaxError(error))),
               ),
     );

// A preview writes nothing, so the newest set of rows wins and an older answer never lands on top.
export const optimumFrictionPreviewTrainingImportEpic = (actions$) =>
     actions$.pipe(
          ofType(
               optimumFrictionConstants.OPTIMUM_FRICTION_PREVIEW_TRAINING_IMPORT_REQUEST,
          ),
          post(
               "/api/optimumFriction/previewTrainingImport",
               optimumFrictionPreviewTrainingImportComplete,
               switchMap,
          ),
     );

// exhaustMap, never mergeMap. A second press while the first commit is still running would grant
// accreditation twice and send a second set of cards on the next worker pass.
export const optimumFrictionCommitTrainingImportEpic = (actions$) =>
     actions$.pipe(
          ofType(
               optimumFrictionConstants.OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_REQUEST,
          ),
          post(
               "/api/optimumFriction/commitTrainingImport",
               optimumFrictionCommitTrainingImportComplete,
               exhaustMap,
          ),
     );

// The history is re-read after every import, so the newest request wins.
export const optimumFrictionGetTrainingImportsEpic = (actions$) =>
     actions$.pipe(
          ofType(
               optimumFrictionConstants.OPTIMUM_FRICTION_GET_TRAINING_IMPORTS_REQUEST,
          ),
          post(
               "/api/optimumFriction/getTrainingImports",
               optimumFrictionGetTrainingImportsComplete,
               switchMap,
          ),
     );

export const optimumFrictionGetReportEpic = (actions$) =>
     actions$.pipe(
          ofType(optimumFrictionConstants.OPTIMUM_FRICTION_GET_REPORT_REQUEST),
          post(
               "/api/optimumFriction/getReport",
               optimumFrictionGetReportComplete,
               switchMap,
          ),
     );

// The export is one unpaged read per click; a newer click replaces an older one still in flight.
export const optimumFrictionGetReportExportEpic = (actions$) =>
     actions$.pipe(
          ofType(optimumFrictionConstants.OPTIMUM_FRICTION_GET_REPORT_EXPORT_REQUEST),
          post(
               "/api/optimumFriction/reportExport",
               optimumFrictionGetReportExportComplete,
               switchMap,
          ),
     );
